import { Col, Row } from "reactstrap";
import { ImagesTitle } from "../../../Constants/Constants";
import { dynamicImage, dynamicNumber, Image } from "../../../Utils";

const Images = () => {
  return (
    <section>
      <Row>
        <Col xs="12">
          <div className="element-card">
            <div className="element-card-header heading">
              <h2>{ImagesTitle}</h2>
            </div>
            <div className="element-card-body typography">
              {dynamicNumber(10).map((item, index) => (
                <Image key={index} className={`img-${item}0 img-fluid`} src={dynamicImage("avtar/1.jpg")} alt="Avatar" />
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </section>
  );
};

export default Images;
